import {
  pathOr,
  flatten,
  match,
  map,
  intersection,
  compose,
  split,
  find,
  length,
} from "ramda";

const maximum = xs => {
  const max = Math.max(...xs);
  return Number.isFinite(max) ? max : 0;
};

export const getMaxDiscount = productTags =>
  compose(
    maximum,
    flatten,
    map(match(/\d+/g)),
    intersection(productTags),
    split(",")
  );

export const getPriorityCampaign = productTags =>
  find(
    compose(length, intersection(productTags), split(","), pathOr("", ["tags"]))
  );
